// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"8d713ec6","58":"3713630a","182":"0087815f","255":"db5ed94e","325":"24970898","453":"18caa7af","599":"640436d0","628":"46de3e14","636":"0a70dd26","718":"72af7674","803":"0f1f00d8","892":"0ad347f5"}[chunkId] + ".chunk.js";
};